module.exports = __webpack_public_path__ + "img/thumbnail-game_on.28b04ae5.png";